/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import SideDrawer from '../../../../components/SideDrawer';
import FBCheckDetails from '../../../Fireboard/components/Body/CheckDetails';
import classes from './CheckDetails.module.css';

const CheckDetails = props => {
  const {
    showCheckDetails,
    onCloseCheckDetails,
    selectedCheck,
    currency,
    iso2,
    items,
    pendingItems,
    showMemberDetailPopup,
    onPrintPress,
    showPopup,
    onRequestRefreshGuestGPS,
    onClickSms,
    openCaptureSeatNamePopup,
    enableAgeRestrictedOrderingForSeat,
    onUpdateAgeRestrictedItemsForSeat,
    sendPendingItems,
    enableAgeVerification,
    enableAgeRestrictedOrderingForCheck,
  } = props;

  const { data: storeInfo } = useSelector(state => state.storeInfo);
  const { enableGpsLocation, latitude, longitude, serverAppFeatures } = storeInfo || {};
  const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } = serverAppFeatures || {};

  const printHandler = (type, printMeta) => {
    onCloseCheckDetails && onCloseCheckDetails();
    onPrintPress && onPrintPress(type, printMeta);
  };

  const viewGuestLocationOnMapHandler = () => {
    onCloseCheckDetails && onCloseCheckDetails();
    showPopup && showPopup('viewOnMap');
  };

  const clickSmsHandler = seatId => {
    onCloseCheckDetails && onCloseCheckDetails();
    onClickSms && onClickSms(seatId);
  };

  const showMemberDetailPopupHandler = memberId => {
    onCloseCheckDetails && onCloseCheckDetails();
    showMemberDetailPopup && showMemberDetailPopup(memberId);
  };

  const requestRefreshGuestGPSHandler = () => {
    onCloseCheckDetails && onCloseCheckDetails();
    onRequestRefreshGuestGPS && onRequestRefreshGuestGPS();
  };

  const onClickRenameSeat = seatId => {
    onCloseCheckDetails && onCloseCheckDetails();
    openCaptureSeatNamePopup && openCaptureSeatNamePopup(seatId);
  };

  const handleAgeRestrictedItemsForSeat = (seatId, disableAgeRestricted) => {
    onCloseCheckDetails && onCloseCheckDetails();
    onUpdateAgeRestrictedItemsForSeat && onUpdateAgeRestrictedItemsForSeat(seatId, disableAgeRestricted);
  };

  const onSendPendingItems = () => {
    onCloseCheckDetails && onCloseCheckDetails();
    sendPendingItems && sendPendingItems();
  };

  return (
    <SideDrawer
      isOpen={showCheckDetails}
      onRequestClose={onCloseCheckDetails}
      width='35%'
      from='right'
    >
      <FBCheckDetails
        checkDetailsStyles={classes.detailsContainer}
        selectedItem={selectedCheck}
        items={items}
        supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
        showMemberDetailPopup={memberId => showMemberDetailPopupHandler(memberId)}
        onPrintPress={(type, printMeta) => printHandler(type, printMeta)}
        getManagerNotifications={[]}
        pendingItems={pendingItems}
        // showApprovalReasonsPopup={showApprovalReasonsPopup}
        currency={currency}
        iso2={iso2}
        suppressTipsOnFireBoard={suppressTipsOnFireBoard}
        // acknowledgeIdCheck={acknowledgeIdCheck}
        enableGpsLocation={enableGpsLocation}
        latitude={latitude}
        longitude={longitude}
        viewGuestLocationOnMap={viewGuestLocationOnMapHandler}
        onRequestRefreshGuestGPS={requestRefreshGuestGPSHandler}
        onClickSms={(seatId) => clickSmsHandler(seatId)}
        openCaptureSeatNamePopup={(seatId) => onClickRenameSeat(seatId)}
        enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
        onUpdateAgeRestrictedItemsForSeat={(seatId, disableAgeRestricted) => handleAgeRestrictedItemsForSeat(seatId, disableAgeRestricted)}
        orderPendingItems={pendingItems}
        sendPendingItems={onSendPendingItems}
        enableAgeVerification={enableAgeVerification}
        enableAgeRestrictedOrderingForCheck={enableAgeRestrictedOrderingForCheck}
      />
    </SideDrawer>
  );
};

export default CheckDetails;
